import React, { useEffect } from 'react';
import ReactGA from "react-ga4";
import { Link } from 'react-router-dom';
import { formationsData } from '../data/formationsData';
import AutresFormationsCarousel from '../components/AutresFormationsCarousel';
import ReassuranceBanner from '../components/ReassuranceBanner';
import '../style/pages/_piloterTiersLieu.scss';

const PiloterTiersLieu = () => {
    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: "/piloter-un-tiers-lieu",
            title: "Piloter un tiers-lieu",
        });
    });

    const piloterData = formationsData.find((project) => project.id === 3);
    if (!piloterData) {
        return <div>Pas de données pour le contenu demandé</div>
    }

    return (
        <div>
            <main>
                <div key={piloterData.id}>

                    <div className="course-banner">
                        <img className="banner-img" src={piloterData.img} alt="" />

                        <section className="course-intro">
                            <div className="course-title">
                                <h1><span className="smaller-title">Formation : </span><br />{piloterData.title}</h1>
                            </div>
                            <p className="course-info_text">{piloterData.info}</p>
                        </section>


                    </div>

                    <div className="o3academie-container">
                        <h2 className="inprogress-course">Nous travaillons activement sur cette formation. <br />
                            Revenez bientôt pour en savoir plus !
                        </h2>
                    </div>

                    <section className="other-courses">
                        <div className="other-courses_content">
                            <div className="title-container">
                                <h3 className="title">Nos autres</h3> <span className="title-bold">formations</span>
                            </div>
                            <AutresFormationsCarousel currentId={piloterData.id} />
                            <div className="button-container">
                                <Link to="/nos-formations" className="yellow-white-button">
                                    Voir toutes les formations
                                </Link>
                            </div>
                        </div>
                    </section>

                    <ReassuranceBanner />
                </div>
            </main>
        </div>
    );
};

export default PiloterTiersLieu;